// EncOverlayScope (design export 21-10, components/EncOverlayScope). Dialogs, drawers, popovers and sheets opened over a frame v2
// encounter screen are portalled to <body>, outside the screen's root. A frame v2 encounter screen calls this hook so <body> carries
// `data-enc-overlay` while it is mounted; the overlay rules of src/styles/showcase/encounter-overlay-look.css hang on that attribute
// and reach only overlay content. Only frame v2 paths call it, so the legacy encounter's overlays are untouched.
import { useLayoutEffect } from 'react';

export function useEncOverlayScope(enabled = true): void {
  useLayoutEffect(() => {
    if (!enabled) return;
    const b = document.body;
    b.setAttribute('data-enc-overlay', '');
    return () => b.removeAttribute('data-enc-overlay');
  }, [enabled]);
}
